import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { PeriodicCampaignEntity } from "../../types/PeriodicCampaignEntity";
import { PeriodicCampaignDtoToEntity } from "../mappers/PeriodicCampaignDtoToEntity";
import { PeriodicCampaignEntityToDto } from "../mappers/PeriodicCampaignEntityToDto";

const PeriodicCampaignApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        PeriodicCampaignLoad: builder.query<PeriodicCampaignEntity, FormQuery>({
            providesTags: [ResourceName.PERIODIC_CAMPAIGN],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PERIODIC_CAMPAIGN}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return PeriodicCampaignDtoToEntity(response);
            },
        }),
        PeriodicCampaignUpdate: builder.mutation<PeriodicCampaignEntity, FormMutation<PeriodicCampaignEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PERIODIC_CAMPAIGN}/${mutation.data.id}`;
                const method = "PUT";

                const body = PeriodicCampaignEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PERIODIC_CAMPAIGN],
        }),
    }),
});

export const { usePeriodicCampaignLoadQuery, usePeriodicCampaignUpdateMutation } = PeriodicCampaignApi;
